import React, { useEffect, useState } from 'react';
import {
  Card,
  CardActionArea,
  CardHeader,
  Grid,
} from '@mui/material';
import {
  Battery20,
  BikeScooter,
  Wifi,
  WifiOff,
} from '@mui/icons-material';
import { voltToPercentage } from '../util/converter';

const CardWrapper = ({ devices, positions, rents, type, callback }) => {
  const [value, setValue] = useState(0);
  const [filtered, setFiltered] = useState([]);
  const [icon, setIcon] = useState();

  function returnFiltered() {
    callback(filtered);
  }

  function countRents() {
    if (!rents) {
      setValue(0);
      return;
    }
    let counterRents = 0;
    const filteredSupport = [];
    rents.forEach((rent) => {
      const dateEnd = rent.dateEnd.split('-');
      if (parseInt(dateEnd[1], 10) < 2000) {
        counterRents += rent.deviceIds.length;
        filteredSupport.push(rent);
      }
    });
    setFiltered(filteredSupport);
    setValue(counterRents);
  }

  function countLowBattery() {
    if (!positions && !devices) {
      setValue(0);
      return;
    }
    let counterLowBattery = 0;
    const filteredSupport = [];
    Object.entries(positions).forEach((value) => {
      let batteryLevel = 0;
      if (value[1].attributes.batteryLevel) {
        batteryLevel = value[1].attributes.batteryLevel;
      }
      if (batteryLevel > 100 || !batteryLevel) {
        batteryLevel = voltToPercentage(value[1].attributes.power, devices[value[1].deviceId].attributes.batteryVoltage);
      }
      if (batteryLevel < 40) {
        counterLowBattery += 1;
        filteredSupport.push(value[1]);
      }
    });
    setFiltered(filteredSupport);
    setValue(counterLowBattery);
  }

  function countOnline() {
    if (!devices) {
      setValue(0);
      return;
    }
    let counterOnline = 0;
    const filteredSupport = [];
    Object.entries(devices).forEach((value) => {
      if (value[1].status === 'online') {
        counterOnline += 1;
        filteredSupport.push(value[1]);
      }
    });
    setFiltered(filteredSupport);
    setValue(counterOnline);
  }

  function countOffline() {
    if (!devices) {
      setValue(0);
      return;
    }
    let counterOffline = 0;
    const filteredSupport = [];
    Object.entries(devices).forEach((value) => {
      if (value[1].status !== 'online') {
        counterOffline += 1;
        filteredSupport.push(value[1]);
      }
    });
    setFiltered(filteredSupport);
    setValue(counterOffline);
  }

  useEffect(() => {
    switch (type) {
      case 'online':
        countOnline();
        setIcon(<Wifi color="success" />);
        break;
      case 'offline':
        countOffline();
        setIcon(<WifiOff color="error" />);
        break;
      case 'lowBattery':
        countLowBattery();
        setIcon(<Battery20 color="error" />);
        break;
      case 'inRide':
        countRents();
        setIcon(<BikeScooter />);
        break;
      default:
        break;
    }
  }, [devices, positions]);

  return (
    <CardActionArea onClick={() => returnFiltered()}>
      <Card elevation={3}>
        <Grid container>
          <Grid item xs={6} style={{ alignSelf: 'center', textAlign: 'center' }}>
            {icon}
          </Grid>
          <Grid item xs={6} style={{ textAlign: 'center' }}>
            <CardHeader title={value} titleTypographyProps={{ fontSize: 20 }} />
          </Grid>
        </Grid>
      </Card>
    </CardActionArea>
  );
};

export default CardWrapper;
